module.exports = __webpack_public_path__ + "img/intro12.a2d3644e.jpg";